/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-cycle */
import React, { useRef, useState, useEffect } from 'react';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Sort,
  Filter,
  Resize,
  Edit,
  Toolbar,
  LazyLoadGroup,
  Group,
  PdfExport,
  ExcelExport,
  ForeignKey,
} from '@syncfusion/ej2-react-grids';
import { ToolbarComponent, ItemsDirective, ItemDirective, AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { DialogUtility, DialogComponent } from '@syncfusion/ej2-react-popups';
import { TextBoxComponent, UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent, SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { Query } from '@syncfusion/ej2-data';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Link, useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import { Header, Events, DevLog } from '../components';
import armband from '../data/watchsketch.png';
import scribeHow from '../data/scribehow.png';

import { invGrid } from '../data/dummy';
import './inventory.css';
import './Zackat.css';

const InventoryControlCenter = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  const { inventoryCount, boss, isMobile, zRenderMode, reloadCounts, setReloadCounts } = useStateContext();

  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=inventorycontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  let dialogInstance;
  const [condensed, setCondensed] = useState(false);

  const { REACT_APP_API_ENDPOINT } = process.env;
  const valuerules = { required: true };
  const [enableEvents, setEvents] = useState(true);
  const [enableRawEvents, setRawEvents] = useState(false);
  const [groups, setGroups] = useState([]);
  const [sortOptions, setSortColumns] = useState({});
  const [reload, setReload] = useState(false);
  const [inventoryid, setInventoryId] = useState('');
  const [selCharger, setCharger] = useState('');
  const [selVersion, setVersion] = useState('');
  const [selRRSP, setRRSP] = useState('');
  const [selUploadOrganization, setUploadOrganization] = useState('');
  const [selDevice, setDevice] = useState('');
  const [selAssociate, setAssociate] = useState('');
  const [selInventoryStatus, setInventoryStatus] = useState('');
  const [selIMEI, setIMEI] = useState('');
  const [selMSN, setMSN] = useState('');
  const [selH2S, setH2S] = useState('');
  const [selStatus, setStatus] = useState('');
  const [selBattery, setBattery] = useState('');
  const [dataChanged, setDataChanged] = useState(false);
  const [inventory, setInventory] = useState(null);
  const [selOrganization, setOrganization] = useState('');
  const orgData = [];
  const associateData = [];
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const grid = useRef(null);
  const [page, setPage] = useState(1);
  const [selectedInventoryRow, setInventoryRow] = useState(1);
  const [currentCount, setCurrentCount] = useState(50);
  const [superUser, setSuperUser] = useState(false);
  const [inventorysearch, setInventorySearch] = useState('');
  const [eventDialog, setEventDialog] = useState(true);
  const [logDialog, setLogDialog] = useState(true);
  const [hideDialog, setDialog] = useState(true);
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  const [crudImport, setCrudImport] = useState(false);
  useEffect(() => {
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Create')) {
      setCrudCreate(true);
    }
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Import')) {
      setCrudImport(true);
    }
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Update')) {
      setCrudUpdate(true);
    }
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Delete')) {
      setCrudDelete(true);
    }
  }, [data]);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const smsFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/sms_config?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      if (mydata && mydata.sms && mydata.sms.length > 0) {
        const mysms = [];
        mydata.sms.forEach((e) => {
          const s = { text: e.name, value: e.syntax };
          mysms.push(s);
        });
        setActions(mysms);
      }
    };
    smsFetch();
  }, [reload]);

  const add = { text: 'Add', tooltipText: 'Add Inventory', prefixIcon: 'e-add', id: 'add', visible: crudCreate, disabled: false };
  const edit = { text: 'Edit', tooltipText: 'Edit Inventory', prefixIcon: 'e-edit', id: 'edit', visible: crudUpdate, disabled: false };
  const del = { text: 'Delete', tooltipText: 'Delete Inventory', prefixIcon: 'e-delete-2', id: 'delete', visible: crudDelete, disabled: false };
  const events = { text: 'Events', tooltipText: 'Inventory Events', prefixIcon: 'e-justify', id: 'events', disabled: false }; // enableEvents
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: false };
  const person = { text: 'Associate', tooltipText: 'Associate', prefixIcon: 'e-user', id: 'associate', disabled: false };
  const toolbarOptions = [add, edit, del, person, events, excel, 'Search'];
  const toolbarNoOptions = ['Search'];
  // 'PdfExport',
  const dataBound = (args) => {
    if (grid && grid.current) {
      grid.current.toolbarModule.toolbar.overflowMode = 'MultiRow';
    }
  };
  /*
  const statusGrid = (props) => (
    <div>
      <pre>
        {props.simstatus && props.simstatus.status ? `${props.status} (${props.simstatus.status})` : props.status}
      </pre>
    </div>
  );
  */
  function changeCondensed() {
    if (groups.length !== 0) {
      DialogUtility.alert('Please remove your grouping before changing the condensed view!');
      return;
    }

    setCondensed(!condensed);
    setUserPreferences('condensed', !condensed);
  }

  const condensedComponent = () => (
    <div>
      <div>
        <label htmlFor="showCondensed">
          Condensed&nbsp;
        </label>
        <SwitchComponent id="showCondensed" checked={condensed} cssClass="bar-color handle-color" onChange={changeCondensed} />
      </div>
    </div>
  );

  const header = () => (
    <div><h1>{inventoryid === 'add_inventory' ? 'Add' : 'Edit'} Inventory {selDevice}</h1></div>
  );
  const handleDialogClick = () => {
    setDialog(!hideDialog);
    // setInventoryId('');
    // setEvents(true);
  };

  const savebuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        saveProfile();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'SAVE',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];
  const addbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        addProfile();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'ADD',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];
  const htmlAttributes = {
    'aria-required': 'true', // Makes the textbox a required field
    required: true,
  };
  const textBoxAttributes = {
    name: 'user-name',
    type: 'text',
    maxLength: '16',
    minLength: '15',
    required: true,
    placeholder: 'Enter your IMEI',
    'aria-required': 'true',
    disabled: false,
  };

  const profileTemplate = () => (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <form>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
          <div className="e-input-group">
            <TextBoxComponent
              placeholder="Associate"
              title="Controlled via Associate tab"
              value={selAssociate || 'unassigned'}
              disabled
              readOnly
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setAssociate(v.value); }}
            />
          </div>
        </div>

        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
          <div className="e-input-group">
            <TextBoxComponent
              placeholder="IMEI"
              value={selIMEI}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setIMEI(v.value); }}
            />
            <TextBoxComponent
              placeholder="MSN"
              value={selMSN}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setMSN(v.value); }}
            />
            <TextBoxComponent
              placeholder="H2S"
              value={selH2S}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setH2S(v.value); }}
            />
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
          <div className="e-input-group">
            <TextBoxComponent
              placeholder="Device"
              value={selDevice}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setDevice(v.value); }}
            />
          </div>
        </div>
        <div className="row custom-margin">
          <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
            <div className="e-input-group">
              <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selOrganization} onChange={(v) => { setOrganization(v.value); }} />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
  const handleLogDialogClick = () => {
    setLogDialog(!logDialog);
  };
  const handleEventDialogClick = () => {
    setEventDialog(!eventDialog);
  };

  const logbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleLogDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },

  ];
  const eventsbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleEventDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];

  const eventTemplate = () => (
    <Events props={inventory} />
  );
  const logTemplate = () => (
    <DevLog props={inventory} />
  );
  const pageComponent = () => (
    <div style={{ float: 'left', width: '200px' }}>
      <div className="col-xs-12 col-sm-12 col-lg-6 col-md-6">
        <label htmlFor="showLimit" style={{ padding: '10px 40px 10px 0' }}>
          {selectedInventoryRow}-{currentCount} / {currentCount < 50 ? currentCount : inventoryCount}
        </label>
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-first-page" onClick={() => { setPage(1); setInventoryRow(1); }} />
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-chevron-left" onClick={() => { let p = page; if (p !== 1) { setPage(p -= 1); setInventoryRow(1); } }} />
        &nbsp;&nbsp;Page {page} of {currentCount < 50 && page === 1 ? Math.ceil(currentCount / 50) : Math.ceil(inventoryCount / 50)}&nbsp;&nbsp;
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-chevron-right" onClick={() => { let p = page; let cnt = inventoryCount; if (currentCount < 50) { cnt = currentCount; } if (p !== Math.ceil(cnt / 50) && p !== Math.ceil(inventoryCount / 50)) { setPage(p += 1); setInventoryRow(1); } }} />
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-last-page" onClick={() => { setPage(Math.ceil(inventoryCount / 50)); setInventoryRow(1); }} />
      </div>
    </div>
  );

  const onToolbarChange = (args) => {
    if (grid && grid.current) {
      if (args.target.textContent === 'Update') {
        grid.current.endEdit();
      }
      if (!args || !args.target) {
        return;
      }
      if (args.target.textContent === 'Edit') {
        const selectedRow = grid.current.getSelectedRecords()[0];
        if (!selectedRow || !selectedRow.device) {
          dialogClick('na', 'Select Device', 'Please select a device!', null);
          return;
        }
        grid.current.startEdit();
      }
      if (args.target.textContent === 'Delete') {
        const selectedRow = grid.current.getSelectedRecords()[0];
        if (!selectedRow || !selectedRow.device) {
          dialogClick('na', 'Select Device', 'Please select a device!', null);
          return;
        }
        args.cancel = true;
        grid.current.deleteRecord(selectedRow);
      }
      if (args.target.textContent === 'Add') {
        grid.current.addRecord();
      }
      if (args.target.textContent === 'Raw Events') {
        const selectedRow = grid.current.getSelectedRecords()[0];
        if (!selectedRow || !selectedRow.device) {
          dialogClick('na', 'Select Device', 'Please select a device!', null);
          return;
        }
        navigate(`../events?device=${selectedRow.device}`);
      }
      if (args.target.textContent === 'Device Log') {
        const selectedRow = grid.current.getSelectedRecords()[0];
        if (!selectedRow || !selectedRow.device) {
          dialogClick('na', 'Select Device', 'Please select a device!', null);
          return;
        }
        setLogDialog(!logDialog);
      }
      if (args.target.textContent === 'PDF Export') {
        const properties = {
          fileName: `PDFExport_Inventory_${new Date().toISOString()}.pdf`,
          pageOrientation: 'Landscape',
        };
        grid.current.pdfExport(properties);
      }
      if (args.target.textContent === 'Excel Export') {
        const properties = {
          fileName: `ExcelExport_Inventory_${new Date().toISOString()}.xlsx`,
        };
        grid.current.excelExport(properties);
      }
    }
  };

  const actionData = [
    { text: 'Not specified', value: 'na' },
    { text: 'Check In', value: '"checkin":"query"' },
    { text: 'Development', value: '"srvr":{"url":"biometric.zackat.com", "port": "10900"}' },
    { text: 'FOTA', value: '"fota":"ind"' },
    { text: 'Locate', value: '"locate":"query"' },
    { text: 'Production', value: 'srvr":{"url":"bio.zackatlabs.com", "port": "10900"}' },
    { text: 'Restart', value: '"reset":"restart"' },
    { text: 'Sleep', value: '"reset":"sleep"' },
    { text: 'SMS', value: '""' },
    { text: 'Staging', value: '"srvr":{"url":"biometric.zackatlabs.com", "port": "10900"}' },
  ];
  const [actions, setActions] = useState(actionData);

  const [selectedOption, setSelectedOption] = useState(actionData[0]);
  const audioData = [
    { text: 'Not specified', value: 'na' },
  ];
  const [selectedAudioOption, setSelectedAudioOption] = useState(audioData[0]);

  function dialogOK(f, element) {
    dialogInstance.hide();
    if (f === 'sms') {
      smsDevice(element);
    }
  }
  function dialogClick(f, hdr, content, element) {
    let ok = null;
    if (f !== 'na') {
      ok = { text: 'OK', click: () => { dialogOK(f, element); } };
      if (grid && grid.current) {
        const selectedRow = grid.current.getSelectedRecords()[0];
        if (!selectedRow) {
          dialogClick('na', 'Inventory Row', 'No device selected', null);
          return;
        }
      }
    }
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }
  function oldSmsDevice(e) {
    if (!grid || !grid.current) {
      return;
    }
    if (!e) {
      dialogClick('na', 'SMS Handler', 'no device selected', null);
      return;
    }
    const selectedRecords = grid.current.getSelectedRecords();
    if (!selectedRecords || selectedRecords.length === 0) {
      dialogClick('na', 'SMS Handler', 'Please select a Device!', null);
      return;
    }
    const b = selectedRecords[0];
    const cmd = e.target.itemData.value;
    setSelectedOption(cmd);
    let message = '';
    if (cmd === 'na') {
      dialogClick('na', 'SMS Handler', 'No command supplied!', null);
      return;
    }
    if (b.device === '') {
      dialogClick('na', 'SMS Handler', 'No Device supplied!', null);
      return;
    }
    b.name = inventory.device;
    if (inventory.associate && inventory.associate.length > 0) {
      b.name = `(${inventory.associate})`;
    }
    if (b.name === '(Place Holder)') {
      b.name = `(${inventory.associate}, ${inventory.device})`;
    }
    if (cmd === 'reset') {
      message = prompt(`Restart device ${b.device} ${b.name} or put device to sleep?`, 'restart');
      if (!message || message.length === 0) {
        return;
      }
      if (message.toLocaleLowerCase() === 'restart') {
        message = '"reset":"restart"';
      } else if (message.toLocaleLowerCase() === 'sleep') {
        message = '"reset":"sleep"';
      } else {
        return;
      }
    } else if (cmd === 'fota') {
      // if (!confirm(`Send a FOTA request to ${b.name}`)) {
      //  return;
      // }
      message = '"fota":"ind"';
    } else if (cmd === 'checkin') {
      // if (!confirm(`Send a Check In request to ${b.name}`)) {
      //  return;
      // }
      message = '"checkin":"ind"';
    } else if (cmd === 'locate') {
      message = '"locate":"query"';
      // if (!confirm(`Send a LOCATE request to ${b.name}`)) {
      //  return;
      // }
    } else if (cmd === 'rehome') {
      message = prompt(`ReHome device ${b.device} ${b.name} production, staging or development?`, 'production');
      if (!message || message.length === 0) {
        return;
      }
      if (message.includes('.') && !boss) {
        return;
      }
      switch (message.toLocaleLowerCase()) {
        case 'production':
          message = '"srvr":{"url":"bio.zackatlabs.com", "port": "10900"}';
          break;
        case 'staging':
          message = '"srvr":{"url":"biometric.zackatlabs.com", "port": "10900"}';
          break;
        case 'development':
          message = '"srvr":{"url":"biometric.zackat.com", "port": "10900"}';
          break;
        default:
          message = `"srvr":{"url":"${message}", "port": "10900"}`;
          break;
      }
    } else {
      message = prompt(`What SMS would you like to send to ${b.device} (${b.name})?`, '');
    }
    if (!message || message.length === 0) {
      return;
    }
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.response !== 'OK') {
          dialogClick('na', 'SMS Handler', `${responseJson.response}`, null);
        } else {
          dialogClick('na', 'SMS Handler', `${cmd} request sent`, null);
        }
        setSelectedOption('na');
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  }
  function smsDevice(e) {
    if (!grid || !grid.current) {
      return;
    }
    if (!e) {
      return;
    }
    const selectedRecords = grid.current.getSelectedRecords();
    if (!selectedRecords || selectedRecords.length === 0) {
      return;
    }
    const b = selectedRecords[0];
    const cmd = e.target.itemData.value;
    setSelectedOption(cmd);
    let message = '';
    if (cmd === 'na') {
      return;
    }
    if (cmd.length > 0 && cmd !== '""') {
      message = cmd;
    } else {
      message = prompt(`What SMS would you like to send to ${b.device} (${b.name})?`, '');
    }
    if (!message || message.length === 0) {
      return;
    }

    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        dialogClick('na', `Success ${cmd}`, responseJson.response, e);
        setSelectedOption('na');
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  }
  const actionComponent = () => (
    <div>
      <DropDownListComponent id="ddlelement" dataSource={actions} placeholder="Device Action" value={selectedOption} onChange={(v) => { dialogClick('sms', 'Send Device Action', `Would you lke to send this action ${v.target.itemData.text}?`, v); }} />
    </div>
  );
  useEffect(() => {
    if (grid && grid.current) {
      const selectedRecords = grid.current.getSelectedRecords();
      if (selectedRecords && selectedRecords.length === 1) {
        setInventoryId(selectedRecords[0]._id);
        selectedRecords[0].source = 'controlpanel';
        setInventory(selectedRecords[0]);
        setEvents(false);
      } else {
        setInventoryId('');
        setInventory(null);
        setEvents(true);
      }
    } else {
      setInventoryId('');
      setEvents(true);
    }
  }, [dataChanged]);
  const saveProfile = () => {
    if (inventory.organizationid !== selOrganization) {
      const result = orgData.find(({ id }) => id === selOrganization);
      if (!confirm(`Would you like to move this Inventory ${inventory.device} from ${inventory.organization} to ${result.value}`)) {
        return;
      }
      inventory.organizationid = selOrganization;
      inventory.organization = result.value;
    }
    if (selDevice.length > 0 && (selDevice.length < 19 || selDevice.length > 20)) {
      dialogClick('na', 'Inventory device', 'Required, please enter a valid device for the Inventory!', null);
      return;
    }
    inventory.msn = selMSN;
    inventory.h2s = selH2S;
    inventory.device = selDevice;
    inventory.imei = selIMEI;
    const inv = [];
    inv.push(inventory);
    fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(inv),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        dialogClick('na', 'Inventory Update', `${selDevice} Profile saved!`, null);
        setDialog(!hideDialog);
        setReload(!reload);
      })
      .catch((error) => {
        dialogClick('na', 'Inventory Update', 'An error has occured during Update!', null);
      });
  };

  const addProfile = () => {
    const result = orgData.find(({ id }) => id === selOrganization);
    const newinventory = {};
    newinventory.organizationid = selOrganization;
    if (!result || !result.value || result.value.length === 0) {
      dialogClick('na', 'Inventory Add Device', 'Please select an Organization!', null);
      return;
    }
    newinventory.organization = result.value;
    if (selIMEI.length > 0 && selIMEI.length >= 15 && selIMEI.length <= 16) {
      newinventory.name = selIMEI;
    } else {
      dialogClick('na', 'Inventory Add IMEI', `Invalid IMEI specified ${selIMEI}`, null);
      return;
    }
    if (selDevice.length >= 19 && selDevice.length <= 20) {
      newinventory.device = selDevice;
    } else {
      dialogClick('na', 'Inventory Add Device', `Invalid Device specified ${selDevice}`, null);
      return;
    }
    newinventory.msn = selMSN;
    newinventory.h2s = selH2S;
    newinventory.imei = selIMEI;
    newinventory.simstatus = {};
    newinventory.status = 'stock';
    newinventory.associate = '';
    newinventory.associateid = '';
    const inv = [];
    inv.push(newinventory);
    fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(inv),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson._id) {
          newinventory._id = responseJson._id;
          setInventoryId(newinventory._id);
        }
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          dialogClick('na', 'Inventory Insert', responseJson.response, null);
        } else {
          dialogClick('na', 'Inventory Insert', `${selDevice} added`, null);
        }
        setDialog(!hideDialog);
        setReload(!reload);
        setReloadCounts(reloadCounts + 1);
      })
      .catch((error) => {
        dialogClick('na', 'Inventory Insert', 'An error has occured during New Inventory Insert!', null);
      });
  };

  const cancelProfile = () => {
    setInventoryId('');
  };
  function rowClicked(args) {
    // setEvents(false);
    if (args) {
      setInventoryRow(args.rowIndex + 1);
      setEvents(false);
      setDataChanged(!dataChanged);
    } else {
      setEvents(false);
    }
  }
  const groupOptions = {
    enableLazyLoading: false,
    columns: groups,
  };

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = 50;
    let p = 0;
    if (page > 1) {
      p = page - 1;
    }
    const skip = p * 50;
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      let url = `${REACT_APP_API_ENDPOINT}/inventory?${query}&skip=${skip}`;
      setLoading(true);
      if (inventorysearch && inventorysearch.length > 0) {
        url = `${REACT_APP_API_ENDPOINT}/inventory?${query}&skip=${skip}&search=${inventorysearch}`;
      }
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          if (mydata && mydata.inventory) {
            setCurrentCount(mydata.inventory.length);
          }
          if (mydata.role && mydata.role.inventory && mydata.role.inventory.permissions.includes('Raw Events')) {
            setRawEvents(true);
          }
          if (mydata.user.preferences.inventory.condensed) {
            const b = mydata.user.preferences.inventory.condensed;
            setCondensed(b);
          }

          if (mydata.user && mydata.user.preferences && mydata.user.preferences.inventory) {
            if (mydata.user.preferences.inventory.group) {
              setGroups(mydata.user.preferences.inventory.group);
            } else {
              setGroups(['organizationid']);
            }
            if (mydata.user.preferences.inventory.sort && mydata.user.preferences.inventory.sort.length > 0 && mydata.user.preferences.inventory.sort[0].direction) {
              const mysortedColumns = { columns: mydata.user.preferences.inventory.sort };
              setSortColumns(mysortedColumns);
            }
          } else {
            setGroups(['organizationid']);
          }
          // set state when the data received
          setData(mydata);
          setLoading(false);
        })
        .catch((error) => {
          dialogClick('na', 'Inventory Page Get error', error, null);
        });
    };
    dataFetch();
  }, [reload, page, inventorysearch, isMobile]);
  const searchThis = () => {
    if (grid && grid.current) {
      const search = document.getElementById('inventorysearch');
      if (search) {
        //        grid.current.search(search.value);
        setInventorySearch(search.value);
      } else {
        setInventorySearch('');
      }
    }
    setInventoryRow(1);
  };
  const handleKeyDown = (e) => {
    // Check if the pressed key is "Enter"
    if (e.key === 'Enter') {
      // Prevent the default form submission behavior
      e.preventDefault();
      // Perform your search or submission logic here
      searchThis(e);
      // Optional: Clear the textbox after searching
      // setValue('');
    }
  };

  const searchComponent = () => (
    <div className="pt-2 relative mx-auto text-gray-600">
      <TextBoxComponent
        placeholder="Search Device, MSN or IMEI"
        value={inventorysearch}
        width="250px"
        required
        id="inventorysearch"
        showClearButton
        cssClass="e-outline"
        floatLabelType="Never"
        onChange={(v) => { if (v.value.length === 0) { setInventorySearch(''); } }}
        onKeyDown={handleKeyDown}
      />
      <button type="button" className="absolute right-0 top-0 mt-5 mr-8" onClick={searchThis}>
        <svg
          className="text-gray-600 h-4 w-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 56.966 56.966"
          xmlSpace="preserve"
          width="512px"
          height="512px"
        >
          <path
            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
          />
        </svg>
      </button>
    </div>
  );

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const inventoryFetch = async () => {
      if (inventoryid !== '' && inventoryid !== 'add_inventory') {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/inventory?${query}&inventoryid=${inventoryid}`;
        if (!usr.loggedIn) {
          navigate('/login');
          return;
        }
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
          .then((response) => response.json())
          .then((mydata) => {
            if (mydata && mydata._id) {
              setStatus(`${mydata.status ? mydata.status : ''}`);
              setBattery(`${mydata.battery ? mydata.battery : ''}`);
              setDevice(`${mydata.device ? mydata.device : ''}`);
              setInventory(mydata);
              setAssociate(`${mydata.associate ? mydata.associate : ''}`);
              setVersion(`${mydata.version ? mydata.version : ''}`);
              setCharger(`${mydata.charger ? mydata.charger : ''}`);
              setRRSP(`${mydata.rssi ? mydata.rssi : ''}`);
              setIMEI(`${mydata.imei ? mydata.imei : ''}`);
              setMSN(`${mydata.msn ? mydata.msn : ''}`);
              setH2S(`${mydata.h2s ? mydata.h2s : ''}`);
              setOrganization(mydata.organizationid ? mydata.organizationid : null);
              setInventoryStatus(`Status:${mydata.status.toUpperCase()}\r\nVersion:${mydata.version}\r\nBattery:${mydata.battery}\r\nCharger:${mydata.charger}\r\nRRSP:${mydata.rssi}\r\n`);
              mydata.source = 'controlpanel';
            }
          })
          .catch((error) => {
            dialogClick('na', 'Inventory Get error', error, null);
          });
      }
    };
    inventoryFetch();
  }, [inventoryid]);

  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.organization) {
    data.organization.forEach((element) => {
      orgData.push({ id: element._id, value: element.title });
    });
  }
  if (data.associates) {
    data.associates.forEach((element) => {
      associateData.push({ id: element._id, value: element.name });
    });
  }

  if (data.role && data.role.inventory && !data.role.inventory.permissions.includes('Read')) {
    return <p>Not authorized...</p>;
  }
  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: false,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Normal',
  };
  function setUserPreferences(pref, val) {
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.inventory) {
      data.user.preferences.inventory = {};
    }
    if (pref === 'group') {
      data.user.preferences.inventory = { group: val, sort: data.user.preferences.inventory.sort, condensed: data.user.preferences.inventory.condensed };
    } else if (pref === 'sort') {
      data.user.preferences.inventory = { group: data.user.preferences.inventory.group, sort: val, condensed: data.user.preferences.inventory.condensed };
    } else if (pref === 'condensed') {
      data.user.preferences.inventory = { group: data.user.preferences.inventory.group, condensed: val, sort: data.user.preferences.inventory.sort };
    }
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          dialogClick('na', `Inventory Preferences error ${pref}`, responseJson.response, null);
        } else {
          // dialogClick('na', 'Inventory Update', `${selDevice} updated`, null);
        }
        // setDialog(!hideDialog);
        setReload(!reload);
      })
      .catch((error) => {
        dialogClick('na', `Inventory Preferences error ${pref}`, error, null);
      });
  }
  const actionBegin = (args) => {
    if (args.requestType === 'ungrouping' || args.requestType === 'grouping') {
      const index = groups.indexOf(args.columnName);
      if (index > -1 && args.requestType === 'ungrouping') { // only splice array when item is found
        groups.splice(index, 1); // 2nd parameter means remove one item only
      } else if (index === -1 && args.requestType === 'grouping') { // only splice array when item is found
        groups.push(args.columnName); // 2nd parameter means remove one item only
      }
      setUserPreferences('group', groups);
    } else if (args.requestType === 'sorting') {
      const sort = [];
      const currentSortSettings = grid.current.sortSettings;
      currentSortSettings.properties.columns.forEach((element) => {
        sort.push(element.properties);
      });

      // setUserPreferences('sort', [{ field: args.columnName, direction: args.direction }]);
      setUserPreferences('sort', sort);
    }
  };
  const associates = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.associates,
      fields: { value: '_id', text: 'name' },
      query: new Query(),
    },
  };

  const actionComplete = (args) => {
    const editedData = args.data;
    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.width = '400px';
        dialog.header = `Details of ${args.rowData.device}`;
      }
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (editedData && editedData.device.length >= 19 && editedData.device.length <= 20) {
        if (isNaN(args.data.device)) {
          dialogClick('na', 'Action Complete error', `NaN Invalid Device ID ${editedData.device}`, null);
          args.cancel = true;
          setReload(!reload);
          return;
        }

        // Here you can send the updated data to your server using AJAX call

        editedData.simstatus = { status: 'active' };
        const oresult = orgData.find(({ id }) => id === editedData.organizationid);
        if (!oresult) {
          dialogClick('na', 'Action Complete Organization error', 'Error finding organization', null);
          args.cancel = true;
          setReload(!reload);
          return;
        }
        editedData.organization = oresult.value;
        const result = associateData.find(({ id }) => id === editedData.inventoryid);
        if (result) {
          editedData.associate = result.value;
        }
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The default edit operation is cancelled
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Action Complete error', responseJson.response, null);

              setReload(!reload);
              args.cancel = true;
            }
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
          })
          .catch((error) => {
            setReload(!reload);
            args.cancel = true;
          });
      } else {
        dialogClick('na', 'Action complete error', `Invalid device ID ${args.data.device}`, null);
        setReload(!reload);
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        const invs = [];
        if (editedData.associateid) {
          const result = associateData.find(({ id }) => id === editedData.inventoryid);
          if (result) {
            editedData.associate = result.value;
          }
        }
        const oresult = orgData.find(({ id }) => id === editedData.organizationid);
        if (!oresult) {
          dialogClick('na', 'Action complete error', 'Error locating Organization', null);
          args.cancel = true;
          setReload(!reload);
          return;
        }
        editedData.organization = oresult.value;
        invs.push(editedData);
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(invs),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The default edit operation is cancelled
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Inventory update', responseJson.response, null);
              args.cancel = true;
            }
            // The added/edited data will be saved in the Grid
          })
          .catch((error) => {
            dialogClick('na', 'Inventory Update', error, null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'batchsave') {
      if (args.rows && args.rows.length > 0) {
        const invs = [];
        for (let x = 0; x < args.rows.length; x++) {
          invs.push(args.rows[x].data);
        }
        // The default edit operation is cancelled

        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(invs),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Inventory update', responseJson.response, null);
              args.cancel = true;
              setReload(!reload);
            }
          })
          .catch((error) => {
            dialogClick('na', 'Inventory update', error, null);
            args.cancel = true;
            setReload(!reload);
          });
      }
    } else if (args.requestType === 'delete') {
      let entry = ' this entry?';
      if (args.data.length > 1) {
        entry = ' these entries?';
      }
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Inventory delete', responseJson.response, null);
              args.cancel = true;
            }
            setInventoryId('');
            setReload(!reload);
            setReloadCounts(reloadCounts - 1);
          })
          .catch((error) => {
            dialogClick('na', 'Inventory delete', error, null);
            args.cancel = true;
            setReload(!reload);
          });
      }
    }
  };

  const onFileUpload = (args) => {
    // add addition data as key-value pair.
    const result = orgData.find(({ id }) => id === selUploadOrganization);
    if (!result || !result.value || result.value === '') {
      dialogClick('na', 'Inventory file upload', 'Invalid Organization', null);
      args.cancel = true;
      return;
    }
    if (!confirm(`Upload to ${result.value}`)) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: selUploadOrganization }];
  };
  let uploadObj;
  const path = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/inventoryremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/inventoryupload`,
  };

  const FilterOptions = {
    type: 'Menu',
  };
  function completeUpload(args) {
    // dialogClick('na', 'Upload success', 'Your upload is complete!', null);
    DialogUtility.alert(`Upload Completed ${args.fileData[0].status}`);
    setReload(!reload);
  }
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };
  const currentThemeColor = localStorage.getItem('colorMode');
  const clickHandler = (args) => {
    if (grid && grid.current && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_Inventory_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.current.pdfExport(properties);
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      /*
      const properties = {
        fileName: `ExcelExport_Inventory_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(properties);
      */
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/excel?${query}&inventory=true`;
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      }).then((response) => response.json())
        .then((responseJson) => {
          // The added/edited data will be saved in the Grid
          dialogClick('na', 'Inventory Excel handler', responseJson.response, null);
        });
    } else if (grid && grid.current && args.item.properties.text === 'Batch') {
      if (grid.current.properties.editSettings.properties.mode === 'Dialog') {
        grid.current.properties.editSettings.properties.mode = 'Batch';
      } else {
        grid.current.properties.editSettings.properties.mode = 'Dialog';
      }
    } else if (grid && grid.current && args.item.properties.text === 'Events') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'Events handler', 'Please select a device', null);
      } else if (selectedRecords && selectedRecords.length === 1) {
        setEventDialog(!eventDialog);
        // navigate(`../events?device=${selectedRecords[0].device}`);
      }
    } else if (grid && grid.current && args.item.properties.text === 'Search') {
      const selectedRecords = grid.current.getSelectedRecords();
      setInventorySearch(selectedRecords[0].name);
    } else if (grid && grid.current && args.item.properties.text === 'Edit') {
      const selectedRow = grid.current.getSelectedRecords()[0];
      if (!selectedRow || !selectedRow.device) {
        dialogClick('na', 'Select Device', 'Please select a device!', null);
        return;
      }
      if (isMobile) {
        grid.current.startEdit(selectedRow);
      } else {
        setDialog(!hideDialog);
      }
    } else if (grid && grid.current && args.item.properties.text === 'Delete') {
      const selectedRow = grid.current.getSelectedRecords()[0];
      args.cancel = true;
      grid.current.deleteRecord(selectedRow);
    } else if (grid && grid.current && args.item.properties.text === 'Add') {
      setDevice('');
      setIMEI('');
      setMSN('');
      setH2S('');
      setOrganization(null);
      setInventory(null);
      setAssociate('');
      setInventoryId('add_inventory');
      setDialog(!hideDialog);
    } else if (grid && args.item.properties.text === 'Associate') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0 || !selectedRecords[0].device || selectedRecords[0].device === '') {
        DialogUtility.alert('Please select a valid device!');
      } else if (!selectedRecords || selectedRecords.length === 0 || !selectedRecords[0].associateid || selectedRecords[0].associateid === '') {
        DialogUtility.alert('Device not paired to an Associate!');
      } else if (selectedRecords && selectedRecords.length === 1 && selectedRecords[0].associateid && selectedRecords[0].device) {
        localStorage.setItem('currentAssociate', selectedRecords[0].device);
        // navigate(`../associatepage?id=${selectedRecords[0].associateid}&name=${selectedRecords[0].resultField[0].name}`);
        navigate('../associatepage');
      }
    }
  };
  const orgRule = { required: true };
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <img
        className="w-20"
        src={armband}
        alt="arm band"
      />
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/Inventory_Devices_features_and_data__1VjJx1-RQe-FY7vi441dYw"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Inventory" title="Devices" />
      </div>
      <div style={{
        backgroundColor: currentThemeColor,
        textAlign: 'left',
        marginTop: '-40px',
      }}
      >
        <div id="droparea">
          {!condensed && crudImport && !isMobile && (
            <div className="control-section accordion-control-section" style={{ width: '45%' }}>
              <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
                <AccordionComponent>
                  <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                    <div className="e-input-group">
                      <div className="mt-4"> Import </div>
                    </div>
                    <div className="mt-2 e-input-group">
                      <div>
                        <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selUploadOrganization} onChange={(v) => { setUploadOrganization(v.value); }} />
                      </div>
                      <UploaderComponent
                        id="fileupload"
                        type="file"
                        ref={(uplaod) => { uploadObj = uplaod; }}
                        asyncSettings={path}
                        buttons={buttons}
                        multiple={false}
                        actionComplete={completeUpload}
                        autoUpload={false}
                        uploading={onFileUpload}
                        allowedExtensions=".csv"
                      />
                    </div>
                  </div>
                </AccordionComponent>
              </div>
            </div>
          )}
          {!loading && (
            <div>
              <ToolbarComponent id="toolbar" onClick={onToolbarChange} overflowMode="MultiRow">
                <ItemsDirective>
                  <ItemDirective text="Raw Events" prefixIcon="e-justify" visible={enableRawEvents} disabled={!enableRawEvents} />
                  <ItemDirective type="Separator" />
                  <ItemDirective text="Device Log" prefixIcon="e-table-of-content" visible={enableRawEvents} disabled={!enableRawEvents} />
                  <ItemDirective type="Separator" />
                  <ItemDirective template={condensedComponent} />
                  <ItemDirective template={actionComponent} disabled={enableEvents} />
                  <ItemDirective type="Separator" />
                  {/*
                <ItemDirective template={audioComponent} disabled={enableEvents} />
                */}
                  <ItemDirective text="Search" template={searchComponent} disabled={false} style={{ float: 'right !important' }} />
                </ItemsDirective>
              </ToolbarComponent>
              <ToolbarComponent id="toolbar2" onClick={onToolbarChange}>
                <ItemsDirective>
                  <ItemDirective template={pageComponent} float="left" />
                </ItemsDirective>
              </ToolbarComponent>
            </div>
          )}
        </div>
        <div style={{
          textAlign: 'left',
        }}
        >
          {!hideDialog && (
            <DialogComponent
              header={header}
              content={profileTemplate}
              buttons={inventoryid !== 'add_inventory' ? savebuttons : addbuttons}
              width="55%"
              height="85%"
              isModal
              visible
              closeOnEscape
              showCloseIcon
              onClose={() => { setInventoryId(''); setDialog(!hideDialog); }}
              close={() => { setDialog(!hideDialog); }}
            />
          )}

          {!eventDialog && (
            <DialogComponent
              header="Events"
              content={eventTemplate}
              buttons={eventsbuttons}
              width="95%"
              height="95%"
              isModal
              visible
              closeOnEscape
              showCloseIcon
              onClose={() => { setEventDialog(!eventDialog); }}
              close={() => { setEventDialog(!eventDialog); }}
            />
          )}

          {!logDialog && (
            <DialogComponent
              header="Device Logs"
              content={logTemplate}
              buttons={logbuttons}
              width="95%"
              height="95%"
              isModal
              visible
              closeOnEscape
              showCloseIcon
              onClose={() => { setLogDialog(!logDialog); }}
              close={() => { setLogDialog(!logDialog); }}
            />
          )}
          <div className="e-adaptive-demo e-bigger">
            <div className="e-mobile-layout">
              <div className="e-mobile-content">
                <div className="flex" height="300px">
                  <GridComponent
                    dataSource={data.inventory}
                    enableHover
                    id="gridinventory"
                    toolbar={!isMobile ? toolbarOptions : toolbarNoOptions}
                    editSettings={editing}
                    allowSorting
                    dataBound={dataBound}
                    allowMultiSorting
                    allowResizing
                    // allowFiltering={data && data.inventory && data.inventory.length > 0}
                    // filterSettings={FilterOptions}
                    actionComplete={actionComplete}
                    actionBegin={actionBegin}
                    toolbarClick={clickHandler}
                    allowTextWrap
                    allowPdfExport
                    allowExcelExport
                    allowGrouping
                    recordClick={rowClicked}
                    groupSettings={groupOptions}
                    sortSettings={sortOptions}
                    ref={grid}
                    width="100%"
                    enableAdaptiveUI={isMobile}
                    enableStickyHeader={!isMobile}
                    rowRenderingMode={zRenderMode}
                    enableAltRow
                    enablePersistence
                  >
                    <ColumnsDirective>
                      <ColumnDirective
                        field="_id"
                        headerText="ID"
                        visible={false}
                        isPrimaryKey
                      />
                      <ColumnDirective
                        field="device"
                        headerText="Device"
                        width="100"
                        textAlign="Left"
                        validationRules={valuerules}
                        visible
                      />
                      {!condensed && (
                        <ColumnDirective
                          field="status"
                          headerText="Status"
                          width="60"
                          textAlign="Left"
                          validationRules={{ required: false }}
                          visible
                        />
                      )}
                      {!condensed && (
                        <ColumnDirective
                          field="simstatus.status"
                          headerText="SIM"
                          width="70"
                          textAlign="Left"
                          validationRules={{ required: false }}
                          visible
                        />
                      )}
                      <ColumnDirective
                        field="imei"
                        headerText="IMEI"
                        width="90"
                        textAlign="Left"
                        validationRules={{ required: false }}
                        visible
                      />
                      <ColumnDirective
                        field="msn"
                        headerText="MSN"
                        width="70"
                        textAlign="Left"
                        validationRules={{ required: false }}
                        visible
                      />
                      <ColumnDirective
                        field="bandId"
                        headerText="Band ID"
                        width="60"
                        textAlign="Left"
                        validationRules={{ required: false }}
                        visible={!isMobile}
                      />
                      <ColumnDirective
                        field="h2s"
                        headerText="H2S"
                        width="70"
                        textAlign="Left"
                        validationRules={{ required: false }}
                        visible={!isMobile}
                      />
                      {!condensed && (
                        <ColumnDirective
                          field="battery"
                          headerText="Battery"
                          width="70"
                          textAlign="Left"
                          validationRules={{ required: false }}
                          visible
                        />
                      )}
                      {!condensed && (
                        <ColumnDirective
                          field="charger"
                          headerText="Charger"
                          width="70"
                          textAlign="Left"
                          validationRules={{ required: false }}
                          visible
                        />
                      )}
                      {!condensed && (
                        <ColumnDirective
                          field="rrsp"
                          headerText="RRSP"
                          width="70"
                          textAlign="Left"
                          validationRules={{ required: false }}
                          visible
                        />
                      )}
                      {!condensed && (
                        <ColumnDirective
                          field="version"
                          headerText="Version"
                          width="70"
                          textAlign="Left"
                          validationRules={{ required: false }}
                          visible
                        />
                      )}
                      {!condensed && (
                        <ColumnDirective
                          field="tzoffset"
                          headerText="TZ Offset"
                          width="70"
                          textAlign="Left"
                          validationRules={{ required: false }}
                          visible
                        />
                      )}
                      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                      { /* invGrid.map((item, index) => <ColumnDirective key={index} {...item} />) */}
                      <ColumnDirective
                        field="organizationid"
                        headerText="Organization"
                        width="80"
                        textAlign="Left"
                        editType="dropdownedit"
                        edit={organizations}
                        validationRules={valuerules}
                        visible
                        foreignKeyField="_id"
                        foreignKeyValue="title"
                        dataSource={organizations.params.dataSource}
                      />
                    </ColumnsDirective>
                    <Inject services={[Edit, Toolbar, Filter, Sort, Resize, PdfExport, ExcelExport, ForeignKey, LazyLoadGroup, Group]} />
                  </GridComponent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InventoryControlCenter;
